<template>
  <div class="flex h-screen w-full items-center justify-center bg-gray-900 text-white">
    <div class="rounded-lg bg-gray-800 p-6 shadow-lg">
      <div class="flex items-center justify-center">
        <svg
          class="h-12 w-12 text-red-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <i>Ative 'Usar tema escuro do site'</i>
      </div>

      <p class="mt-3 text-xl font-bold">Depois recarregue a página.</p>
    </div>

    <div class="mt-3 flex w-full items-center" @click="handleClick">
      <button
        class="flex-1 rounded-md bg-gray-100 px-4 py-2 text-sm font-medium text-gray-800 hover:bg-gray-200"
      >
        OK
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { displayNone } from '@/animations';
  import { lenis } from '@/main';
  import { onMounted } from 'vue';

  const handleClick = () => {
    displayNone('#samsung-error-modal');
  };

  onMounted(() => {
    lenis.stop();
  });
</script>
